/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ account: NonNullable<unknown> }} Notice_ClickedInputs */

const en_notice_clicked = /** @type {(inputs: Notice_ClickedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.account} clicked a link in an email`)
};

/**
* | output |
* | --- |
* | "{account} clicked a link in an email" |
*
* @param {Notice_ClickedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const notice_clicked = /** @type {((inputs: Notice_ClickedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notice_ClickedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notice_clicked(inputs)
});